<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4
            slot="header"
            class="card-title text-left"
            style="padding: 0px; margin: 0px;"
          >
            Adicionar Nova Escala
          </h4>

          <div>
            <h5
              class="card-title text-left mt-0 pt-0"
              style="padding: 0px; margin: 0px;"
            >
              <b>Funcionários:</b> Selecione um ou mais funcionários
            </h5>

            <div class="row mt-3">
              <div class="col-md-12 text-left">
                <base-input>
                  <el-select
                    class="select-success"
                    size="large"
                    multiple
                    filterable
                    collapse-tags
                    placeholder="Selecione os funcionários"
                    v-model="funcionariosSelecionados"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="func in funcionarios"
                      :key="func.id"
                      :label="func.nome"
                      :value="func.id"
                    />
                  </el-select>
                </base-input>
              </div>
            </div>
          </div>

          <div
            class="d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div>
              <base-button
                type="info"
                class="animation-on-hover"
                @click="voltar()"
              >
                <i class="tim-icons icon-minimal-left"></i> Voltar
              </base-button>
            </div>
          </div>

          <div style="margin-top: 20px;">
            <div class="row">
              <div class="col-md-4 text-left">
                <h4 slot="header" class="card-title">De</h4>
                <base-input
                  type="date"
                  :min="'1900-01-01'"
                  :max="moment(dataFinal).format('YYYY-MM-DD')"
                  v-model="dataInicial"
                />
              </div>

              <div class="col-md-4 text-left">
                <h4 slot="header" class="card-title">Até</h4>
                <base-input
                  type="date"
                  :min="moment(dataInicial).format('YYYY-MM-DD')"
                  :max="
                    moment()
                      .endOf('year')
                      .format('YYYY-MM-DD')
                  "
                  v-model="dataFinal"
                  :disabled="!dataInicial ? true : false"
                />
              </div>

              <div class="col-md-4 text-left">
                <h4 slot="header" class="card-title">Quantidades de Colunas</h4>
                <base-input>
                  <el-select
                    class="select-success"
                    size="large"
                    placeholder="Single Select"
                    v-model="qtdColunasSelecionadas"
                  >
                    <el-option class="select-success" label="2" value="2"
                      >2</el-option
                    >
                    <el-option class="select-success" label="4" value="4"
                      >4</el-option
                    >
                    <el-option class="select-success" label="6" value="6"
                      >6</el-option
                    >
                    <el-option class="select-success" label="8" value="8"
                      >8</el-option
                    >
                  </el-select>
                </base-input>
              </div>
            </div>

            <div class="row" style="margin-top: 10px;">
              <div class="col-md-3 text-left">
                <h4 slot="header" class="card-title">Entrada / Saída 1</h4>
                <div class="d-flex flex-row justify-content-between">
                  <input
                    type="time"
                    class="form-control"
                    style="margin: 0px 5px 0px 0px;"
                    v-model="entrada1"
                  />
                  <input
                    type="time"
                    class="form-control"
                    style="margin: 0px 0px 0px 5px;"
                    v-model="saida1"
                  />
                </div>
              </div>

              <div
                class="col-md-3 text-left"
                v-show="qtdColunasSelecionadas == 2"
              >
                <h4 slot="header" class="card-title">Descanso</h4>
                <input type="time" class="form-control" v-model="descanco" />
              </div>

              <div
                class="col-md-3 text-left"
                v-show="qtdColunasSelecionadas >= 4"
              >
                <h4 slot="header" class="card-title">Entrada / Saída 2</h4>
                <div class="d-flex flex-row justify-content-between">
                  <input
                    type="time"
                    class="form-control"
                    style="margin: 0px 5px 0px 0px;"
                    v-model="entrada2"
                  />
                  <input
                    type="time"
                    class="form-control"
                    style="margin: 0px 0px 0px 5px;"
                    v-model="saida2"
                  />
                </div>
              </div>

              <div
                class="col-md-3 text-left"
                v-show="qtdColunasSelecionadas >= 6"
              >
                <h4 slot="header" class="card-title">Entrada / Saída 3</h4>
                <div class="d-flex flex-row justify-content-between">
                  <input
                    type="time"
                    class="form-control"
                    style="margin: 0px 5px 0px 0px;"
                    v-model="entrada3"
                  />
                  <input
                    type="time"
                    class="form-control"
                    style="margin: 0px 0px 0px 5px;"
                    v-model="saida3"
                  />
                </div>
              </div>

              <div
                class="col-md-3 text-left"
                v-show="qtdColunasSelecionadas == 8"
              >
                <h4 slot="header" class="card-title">Entrada / Saída 4</h4>
                <div class="d-flex flex-row justify-content-between">
                  <input
                    type="time"
                    class="form-control"
                    style="margin: 0px 5px 0px 0px;"
                    v-model="entrada4"
                  />
                  <input
                    type="time"
                    class="form-control"
                    style="margin: 0px 0px 0px 5px;"
                    v-model="saida4"
                  />
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12 text-left">
                <h4 class="card-title">
                  Selecione os dias para preencher os horários
                </h4>
              </div>

              <div class="col-md-12 d-flex justify-content-between flex-wrap">
                <base-checkbox v-model="allDias" @input="marcarTodosDias">
                  Todos os dias
                </base-checkbox>

                <base-checkbox v-model="domingo">Domingo</base-checkbox>
                <base-checkbox v-model="segunda">Segunda</base-checkbox>
                <base-checkbox v-model="terca">Terça</base-checkbox>
                <base-checkbox v-model="quarta">Quarta</base-checkbox>
                <base-checkbox v-model="quinta">Quinta</base-checkbox>
                <base-checkbox v-model="sexta">Sexta</base-checkbox>
                <base-checkbox v-model="sabado">Sábado</base-checkbox>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-12">
                <base-button
                  :disabled="
                    !dataInicial ||
                      !dataFinal ||
                      funcionariosSelecionados.length === 0
                  "
                  block
                  type="primary"
                  @click="copiarParaBaixo()"
                >
                  Preencher Horários
                </base-button>
              </div>
            </div>

            <div
              class="row d-flex justify-content-between mt-2"
              v-if="diaSelecionar.length > 0"
            >
              <div class="col-md-6">
                <base-input
                  class="text-left"
                  label="Selecione os dias da semana de FOLGA"
                >
                  <select
                    v-model="diaSem"
                    @change="aplicarDiaSemana(diaSem)"
                    class="form-control"
                  >
                    <option value="0">Domingo</option>
                    <option value="1">Segunda</option>
                    <option value="2">Terça</option>
                    <option value="3">Quarta</option>
                    <option value="4">Quinta</option>
                    <option value="5">Sexta</option>
                    <option value="6">Sábado</option>
                  </select>
                </base-input>
              </div>

              <div class="col-md-6">
                <base-input
                  class="text-left"
                  label="Selecione os dias pares ou ímpares de FOLGA"
                >
                  <select
                    v-model="folgaParImpar"
                    @change="aplicarParesDiaSemana()"
                    class="form-control"
                  >
                    <option value="0">Pares</option>
                    <option value="1">Ímpares</option>
                  </select>
                </base-input>
              </div>
            </div>

            <div class="row" v-if="diaSelecionar.length > 0">
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>Folga</th>
                        <th>Dia</th>
                        <th>Data</th>
                        <th>Qtd</th>
                        <th>Entrada 1</th>
                        <th>Saída 1</th>

                        <th v-if="possuiQtd2()">Descanso</th>

                        <th v-if="possuiQtd4()">Entrada 2</th>
                        <th v-if="possuiQtd4()">Saída 2</th>

                        <th v-if="possuiQtd6()">Entrada 3</th>
                        <th v-if="possuiQtd6()">Saída 3</th>

                        <th v-if="possuiQtd8()">Entrada 4</th>
                        <th v-if="possuiQtd8()">Saída 4</th>

                        <th>Ações</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="item in diaSelecionar" :key="item.id">
                        <td>
                          <base-checkbox v-model="item.folga"></base-checkbox>
                        </td>

                        <td>{{ item.dia }}</td>
                        <td>{{ moment(item.data).format("DD/MM/YYYY") }}</td>
                        <td>{{ item.qtdColunas || "-" }}</td>

                        <td>
                          <input
                            v-if="item.qtdColunas"
                            type="time"
                            class="form-control"
                            v-model="item.entrada1"
                          />
                        </td>

                        <td>
                          <input
                            v-if="item.qtdColunas"
                            type="time"
                            class="form-control"
                            v-model="item.saida1"
                          />
                        </td>

                        <td v-if="possuiQtd2()">
                          <input
                            v-if="item.qtdColunas == 2"
                            type="time"
                            class="form-control"
                            v-model="item.descanco"
                          />
                        </td>

                        <td v-if="possuiQtd4()">
                          <input
                            v-if="item.qtdColunas >= 4"
                            type="time"
                            class="form-control"
                            v-model="item.entrada2"
                          />
                        </td>

                        <td v-if="possuiQtd4()">
                          <input
                            v-if="item.qtdColunas >= 4"
                            type="time"
                            class="form-control"
                            v-model="item.saida2"
                          />
                        </td>

                        <td v-if="possuiQtd6()">
                          <input
                            v-if="item.qtdColunas >= 6"
                            type="time"
                            class="form-control"
                            v-model="item.entrada3"
                          />
                        </td>

                        <td v-if="possuiQtd6()">
                          <input
                            v-if="item.qtdColunas >= 6"
                            type="time"
                            class="form-control"
                            v-model="item.saida3"
                          />
                        </td>

                        <td v-if="possuiQtd8()">
                          <input
                            v-if="item.qtdColunas >= 8"
                            type="time"
                            class="form-control"
                            v-model="item.entrada4"
                          />
                        </td>

                        <td v-if="possuiQtd8()">
                          <input
                            v-if="item.qtdColunas >= 8"
                            type="time"
                            class="form-control"
                            v-model="item.saida4"
                          />
                        </td>

                        <td>
                          <el-tooltip
                            content="Excluir"
                            effect="light"
                            :open-delay="300"
                            placement="top"
                          >
                            <base-button
                              @click.native="handleDelete(item)"
                              class="remove btn-link"
                              type="danger"
                              size="sm"
                              icon
                            >
                              <i class="tim-icons icon-simple-remove"></i>
                            </base-button>
                          </el-tooltip>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <base-button
                  type="success"
                  block
                  class="animation-on-hover"
                  style="margin: 0px 5px 0px 5px;"
                  :disabled="
                    funcionariosSelecionados.length === 0 ||
                      diaSelecionar.length === 0
                  "
                  @click="cadastrarEscalas()"
                >
                  Salvar
                </base-button>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      />
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import Modal from "@/components/Modal.vue";

export default {
  name: "cadastrar-escalas",

  props: {
    funcionarios: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
    Modal,
  },

  data() {
    return {
      funcionariosSelecionados: [],

      folgaParImpar: null,
      diaSem: null,

      dataInicial: "",
      dataFinal: "",

      allDias: true,
      domingo: true,
      segunda: true,
      terca: true,
      quarta: true,
      quinta: true,
      sexta: true,
      sabado: true,

      entrada1: "",
      entrada2: "",
      entrada3: "",
      entrada4: "",

      saida1: "",
      saida2: "",
      saida3: "",
      saida4: "",

      descanco: "",

      qtdColunasSelecionadas: 4,

      diaSelecionar: [],
      isLoading: false,
    };
  },

  watch: {
    domingo: "atualizarAllDias",
    segunda: "atualizarAllDias",
    terca: "atualizarAllDias",
    quarta: "atualizarAllDias",
    quinta: "atualizarAllDias",
    sexta: "atualizarAllDias",
    sabado: "atualizarAllDias",
  },

  methods: {
    voltar() {
      this.$emit("voltar", true);
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title,
          text,
          type: typeMsg,
          timer: 2000,
          showConfirmButton: false,
        });
      }
    },

    moment(data) {
      return moment(data);
    },

    verifyDay(day) {
      switch (day) {
        case 0:
          return "Domingo";
        case 1:
          return "Segunda";
        case 2:
          return "Terça";
        case 3:
          return "Quarta";
        case 4:
          return "Quinta";
        case 5:
          return "Sexta";
        case 6:
          return "Sábado";
        default:
          return "";
      }
    },

    marcarTodosDias() {
      this.domingo = this.allDias;
      this.segunda = this.allDias;
      this.terca = this.allDias;
      this.quarta = this.allDias;
      this.quinta = this.allDias;
      this.sexta = this.allDias;
      this.sabado = this.allDias;
    },

    atualizarAllDias() {
      this.allDias =
        this.domingo &&
        this.segunda &&
        this.terca &&
        this.quarta &&
        this.quinta &&
        this.sexta &&
        this.sabado;
    },

    diaEstaSelecionado(diaNumerico) {
      const diasSelecionados = {
        0: this.domingo,
        1: this.segunda,
        2: this.terca,
        3: this.quarta,
        4: this.quinta,
        5: this.sexta,
        6: this.sabado,
      };

      return diasSelecionados[diaNumerico];
    },

    existeDiaSelecionado() {
      return (
        this.domingo ||
        this.segunda ||
        this.terca ||
        this.quarta ||
        this.quinta ||
        this.sexta ||
        this.sabado
      );
    },

    gerarTodosOsDiasDoPeriodo() {
      this.diaSelecionar = [];

      const date1 = this.moment(this.dataInicial, "YYYY-MM-DD");
      const date2 = this.moment(this.dataFinal, "YYYY-MM-DD");

      const diffDays = date2.diff(date1, "days");

      let primeiroDia = date1.day();
      let dataPrimeiroDia = date1.clone();
      let contId = 1;

      for (let i = 0; i <= diffDays; i++) {
        this.diaSelecionar.push({
          id: contId,
          dia: this.verifyDay(primeiroDia),
          diaNumerico: primeiroDia,
          data: dataPrimeiroDia.format("YYYY-MM-DD"),
          folga: false,
          qtdColunas: null,
          entrada1: "",
          saida1: "",
          entrada2: "",
          saida2: "",
          entrada3: "",
          saida3: "",
          entrada4: "",
          saida4: "",
          descanco: "",
        });

        primeiroDia = (primeiroDia + 1) % 7;
        dataPrimeiroDia.add(1, "days");
        contId++;
      }
    },

    copiarParaBaixo() {
      if (
        !this.validarData(this.dataInicial) ||
        !this.validarData(this.dataFinal)
      ) {
        this.showSwal(
          "auto-close",
          "Data inválida",
          "Informe uma data válida.",
          "error",
        );

        return;
      }

      if (!this.existeDiaSelecionado()) {
        this.showSwal(
          "auto-close",
          "Atenção",
          "Selecione pelo menos um dia da semana!",
          "warning",
        );
        return;
      }

      if (!this.diaSelecionar.length) {
        this.gerarTodosOsDiasDoPeriodo();
      }

      const qtd = Number(this.qtdColunasSelecionadas);

      this.diaSelecionar = this.diaSelecionar.map((item) => {
        if (!this.diaEstaSelecionado(item.diaNumerico)) {
          return item;
        }

        return {
          ...item,
          qtdColunas: qtd,

          entrada1: this.entrada1,
          saida1: this.saida1,

          descanco: qtd === 2 ? this.descanco : "",

          entrada2: qtd >= 4 ? this.entrada2 : "",
          saida2: qtd >= 4 ? this.saida2 : "",

          entrada3: qtd >= 6 ? this.entrada3 : "",
          saida3: qtd >= 6 ? this.saida3 : "",

          entrada4: qtd >= 8 ? this.entrada4 : "",
          saida4: qtd >= 8 ? this.saida4 : "",
        };
      });
    },

    aplicarParesDiaSemana() {
      this.diaSelecionar = this.diaSelecionar.map((data) => {
        const dia = moment(data.data).date();
        const resultado = dia % 2 == Number(this.folgaParImpar);

        if (resultado) {
          data.folga = true;
        }

        return data;
      });
    },

    aplicarDiaSemana(dia) {
      this.diaSelecionar = this.diaSelecionar.map((data) => {
        if (dia == data.diaNumerico) {
          data.folga = true;
        }

        return data;
      });
    },

    possuiQtd2() {
      return this.diaSelecionar.some((d) => Number(d.qtdColunas) === 2);
    },

    possuiQtd4() {
      return this.diaSelecionar.some((d) => Number(d.qtdColunas) >= 4);
    },

    possuiQtd6() {
      return this.diaSelecionar.some((d) => Number(d.qtdColunas) >= 6);
    },

    possuiQtd8() {
      return this.diaSelecionar.some((d) => Number(d.qtdColunas) >= 8);
    },

    handleDelete(item) {
      this.diaSelecionar = this.diaSelecionar.filter((ds) => ds.id !== item.id);
    },

    validarData(dataEnviada) {
      const anoAtual = this.moment().year();

      const dataValida = this.moment(dataEnviada).isValid();
      const ano = Number(dataEnviada.split("-")[0]);

      console.log("dataEnviada: ", dataEnviada);
      console.log("dataValida: ", dataValida);
      console.log("ano: ", ano);

      if (!dataValida || ano < 1900 || ano > anoAtual) {
        return false;
      }

      return true;
    },

    cadastrarEscalas() {
      const th = this;
      this.isLoading = true;

      if (this.funcionariosSelecionados.length === 0) {
        this.isLoading = false;
        this.showSwal(
          "auto-close",
          "Atenção",
          "Selecione pelo menos um funcionário!",
          "warning",
        );
        return;
      }

      if (this.diaSelecionar.length === 0) {
        this.isLoading = false;
        this.showSwal(
          "auto-close",
          "Atenção",
          "Clique em preencher horários antes de salvar!",
          "warning",
        );
        return;
      }

      const datas = this.diaSelecionar.map((d) => {
        const item = {
          ...d,
          folga: d.folga ? 1 : 0,
          descanco: d.descanco || "",
        };

        if (!item.qtdColunas) {
          item.qtdColunas = null;
        }

        if (item.descanco === "") delete item.descanco;

        if (item.entrada2 === "") delete item.entrada2;
        if (item.entrada3 === "") delete item.entrada3;
        if (item.entrada4 === "") delete item.entrada4;

        if (item.saida2 === "") delete item.saida2;
        if (item.saida3 === "") delete item.saida3;
        if (item.saida4 === "") delete item.saida4;

        return item;
      });

      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        funcionarios: this.funcionariosSelecionados,
        data_inicial: this.dataInicial,
        data_final: this.dataFinal,
        datas,
      };

      this.axios
        .post("/api/escalas/cadastrarEscalaMensal", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;

          if (response.data.status === "success") {
            th.showSwal(
              "auto-close",
              "Sucesso",
              response.data.message || "Escalas cadastradas com sucesso!",
              "success",
            );

            th.voltar();
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              response.data.message || "Erro ao cadastrar escala mensal!",
              "error",
            );
          }
        })
        .catch((err) => {
          th.isLoading = false;

          const message =
            err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : "Erro ao cadastrar escala mensal!";

          th.showSwal("auto-close", "Erro", message, "error");
        });
    },
  },
};
</script>
